import { ForbiddenException } from '../exceptions/ForbiddenException'
import { NotFoundException } from '../exceptions/NotFoundException'
import { BadRequestException } from '../exceptions/BadRequestException'
import { AbstractModel } from './AbstractModel'
import { RallyRound } from './RallyRound'
import { SerializationHelper } from '../utils/SerializationHelper'
import { Team } from './Team'
import { VehicleClass } from './VehicleClass'

export class Rally extends AbstractModel {
    public id: number|null = null;
    public name: string|null = null;
    public rounds: RallyRound[] = [];
    public rallyRounds: RallyRound[] = [];
    public description: string | null = null;
    public liabilityDisclaimer = '';
    public image: string | null = null;
    public roundName: string | null = null;
    public vehicleClasses: VehicleClass[] = [];
    public termId: number | null = null;

    get isPothole (): boolean {
      return this.id === 5
    }

    get isMoped (): boolean {
      return this.id === 6
    }

    get rallyLinkWebsite (): string {
      switch (this.id) {
        case 5:
          return '/pothole-rodeo.1204.html'
        case 6:
          return '/moped-rodeo.1205.html'
        case 7:
          return '/pothole-rodeo.1204.html'
        case 8:
          return '/pothole-rodeo.1204.html'
        case 9:
          return '/boat-rodeo-austria.1271.html'
        case 11:
          return '/europe-africa-rodeo.1206.html'
        default:
          return '#'
      }
    }

    get rallyParticipantsName () {
      /* if (this.isMoped) {
        return 'Riders'
      } */
      return 'Teams'
    }

    get teamVehicleName (): string {
      // BAC-256
      /* if (this.isMoped) {
        return 'Bike'
      } */
      return 'Team'
    }

    get memberTypeHasName (): {singular: string; plural: string} {
      if (this.isMoped) {
        return { singular: 'Ich habe', plural: 'Unser Team hat' }
      } else {
        return { singular: 'Ich habe', plural: 'Unser Team hat' }
      }
    }

    get vehicleClassesStringArray () {
      return this.vehicleClasses.map((vehicleClasses) => {
        return vehicleClasses.name
      })
    }
}
